// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3vR0e","container":"styles_container__38Myh","title":"styles_title__3Rhht","wrapper":"styles_wrapper__21K8O","answer":"styles_answer__19iR9"};